<script>
  import AccessoryListItem from '@/features/accessories/list/presentation/components/AccessoryListItem'
  export default {
    name: 'Accessories',
    components: {
      AccessoryListItem,
    },
    data () {
      return {
        categories: [
          {
            "name" : "KAYAK",
            "slug" : "kayak",
          },
          {
            "name" : "VESTIARIO",
            "slug" : "clothing",
          },
          {
            "name" : "GIUBBOTTI SALVATAGGIO ",
            "slug" : "lifejacket",
          },
          {
            "name" : "CONTENITORI",
            "slug" : "packaging",
          },
          {
            "name" : "SICUREZZA",
            "slug" : "safety",
          },
          {
            "name" : "PARASPRUZZI",
            "slug" : "spraydecks",
          },
          {
            "name" : "TRASPORTO",
            "slug" : "transport",
          },
        ],
        categorySelected: null,
        items: []
      }
    },
    methods: {
      getAccessories(categorySlug) {
        try {
          var json = require('@/assets/data/json/accessories/' + categorySlug.slug + '/items.json');
          this.items = json
        }
        catch (e) {
          console.log('getAccessories: error')
          console.log(e)
          return;
        }
      },
      sortAccessoriesByName(items) {
        items.sort(function(a, b) {
          var nameA = a.name.toUpperCase();
          var nameB = b.name.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      },
      onCategoryPressed(category) {
        this.items = []
        this.categorySelected = category;
        this.getAccessories(this.categorySelected)
        this.sortAccessoriesByName(this.items)
      },
      isChipSelected(category) {
        if (this.categorySelected == null)
          return false;
        return this.categorySelected == category
      }
    },
    mounted () {
      this.categorySelected = this.categories[0];
      this.getAccessories(this.categorySelected)
      this.sortAccessoriesByName(this.items)
    }
  }
</script>

<template>
  <b-container
    class="main-content mb-5">
    <br/>
    <b-row>
      <div class="scrollmenu">
        <span
          class="badge badge-pill"
          :class="{ 'grey-bg-color': !isChipSelected(category), 'badge-primary': isChipSelected(category) }"
          style="cursor: pointer; margin-left: 6px;"
          @click="onCategoryPressed(category)"
          v-for="category in categories">
          {{ category.name.toUpperCase() }}
        </span>
      </div>
    </b-row>
    <b-row>
      <accessory-list-item
        v-for="item in items"
        :key="item.id"
        :item="item"
        :category="categorySelected">
      </accessory-list-item>
    </b-row>
  </b-container>
</template>

<style scoped>
.scrollmenu {
  margin: auto;
  overflow: auto;
  white-space: nowrap;
  padding-left: 10px;
  padding-right: 15px;
  padding-top: 25px;
  padding-bottom: 25px;
}
/* Hide scrollbar for Chrome, Safari and Opera */
.scrollmenu::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.scrollmenu {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
.badge-pill {
  padding-right: 1.6em;
  padding-left: 1.6em;
  border-radius: 51rem;
  padding-top: 0.6em;
  padding-bottom: 0.6em;
}
</style>
